// ─── Cart UI ────────────────────────────────────────────────────────────────
 
const openBtn  = document.getElementById("open_cart_btn");
const cart     = document.getElementById("sidecart");
const closeBtn = document.getElementById("close_btn");
const backdrop = document.querySelector(".backdrop");
 
openBtn.addEventListener("click", openCart);
closeBtn.addEventListener("click", closeCart);
backdrop.addEventListener("click", closeCart);
 
function openCart() {
  cart.classList.add("open");
  backdrop.classList.add("show");
  document.body.style.overflow = "hidden";
}
 
function closeCart() {
  cart.classList.remove("open");
  backdrop.classList.remove("show");
  document.body.style.overflow = "visible";
}
 
document.querySelector(".cart_content").addEventListener("click", (event) => {
  if (event.target.closest(".close_btn")) closeCart();
});
 
// ─── Loading state ────────────────────────────────────────────────────────────
 
function setCartLoading(isLoading) {
  const cartContent = document.querySelector(".cart_content");
  if (cartContent) cartContent.classList.toggle("cart--loading", isLoading);
}
 
// ─── Update cart drawer + count in parallel ───────────────────────────────────
 
async function updateCart() {
  try {
    const [drawerRes, countRes] = await Promise.all([
      fetch("/?section_id=cart-drawer"),
      fetch("/cart.js"),
    ]);
 
    const text = await drawerRes.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const newContent  = html.querySelector(".cart_content");
    const cartContent = document.querySelector(".cart_content");
    if (cartContent && newContent) {
      cartContent.innerHTML = newContent.innerHTML;
    }
 
    const updatedCart = await countRes.json();
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = updatedCart.item_count;
    });
 
    addRemoveButtonListeners();
    addAddOnItemListeners();
 
  } catch (error) {
    console.error("updateCart failed", error);
  } finally {
    setCartLoading(false);
  }
}
 
// ─── Add to cart ──────────────────────────────────────────────────────────────
 
async function addToCart(form) {
  setCartLoading(true);
 
  try {
    const isForm = form instanceof HTMLFormElement;
    const res = await fetch("/cart/add.js", {
      method: "POST",
      body: isForm
        ? new FormData(form)
        : new URLSearchParams({ id: form.dataset.variantId, quantity: form.dataset.quantity || 1 }),
    });
 
    if (res.status >= 400) {
      console.error("Failed to add to cart", await res.text());
      setCartLoading(false);
      return;
    }
  } catch (error) {
    console.error("addToCart fetch failed", error);
    setCartLoading(false);
    return;
  }
 
  await updateCart();
}
 
// Wire up add-to-cart forms via event delegation
document.addEventListener("submit", async (event) => {
  const form = event.target.closest('form[action="/cart/add"]');
  if (!form) return;
  event.preventDefault();
  openCart();
  optimisticallyAddItem(form);
  addToCart(form);
});
 
// ─── Optimistic item render ───────────────────────────────────────────────────
 
function optimisticallyAddItem(form) {
  const select = form.querySelector('select[name="id"], select[name="variant"]') || form.querySelector('#variant-select-desktop');
  const variantId = select ? select.value : form.querySelector('input[name="id"]')?.value;
  const title = select && select.selectedOptions[0]
    ? select.selectedOptions[0].text.trim()
    : document.querySelector('.product-title, h1.title, h1')?.textContent.trim() || 'Adding...';
 
const imgEl = document.querySelector('#product-image');
  const imgSrc = imgEl ? imgEl.src : '';
 
  const tempItem = document.createElement('div');
  tempItem.className = 'cart_item';
  tempItem.dataset.optimistic = true;
  tempItem.style.opacity = '0';
  tempItem.style.transition = 'opacity 0.2s ease';
  tempItem.innerHTML = `
    <div class="item_img">
      ${imgSrc ? `<img src="${imgSrc}" style="width:100px;object-fit:contain;" />` : ''}
    </div>
    <div class="item_details">
      <h3>${title}</h3>
      <p style="color:black;font-size:12px;"><b>Quantity</b> x 1</p>
      <p style="color:#aaa;font-size:12px;">Adding...</p>
    </div>
  `;
 
  // Find or CREATE the cart_items container if cart is empty
  let cartItems = document.querySelector('.cart_items');
  if (!cartItems) {
    // Remove the empty state message
    const emptyMsg = document.querySelector('.cart-empty');
    if (emptyMsg) emptyMsg.remove();
 
    cartItems = document.createElement('div');
    cartItems.className = 'cart_items';
 
    // Insert before cart_actions or cart-buttons
    const cartContent = document.querySelector('.cart_content');
    const cartActions = document.querySelector('.cart_actions');
    const cartButtons = document.querySelector('#cart-buttons');
    const insertBefore = cartActions || cartButtons;
    if (insertBefore) {
      cartContent.insertBefore(cartItems, insertBefore);
    } else {
      cartContent.appendChild(cartItems);
    }
  }
 
  cartItems.appendChild(tempItem);
  requestAnimationFrame(() => { tempItem.style.opacity = '1'; });
}
 
// ─── Remove item ──────────────────────────────────────────────────────────────
 
async function removeItem(event) {
  const btn       = event.currentTarget;
  const cartItem  = btn.closest("[data-cart-item]");
  const variantId = parseInt(btn.dataset.variantId);
 
  // Optimistically hide
  if (cartItem) {
    cartItem.style.transition = "opacity 0.15s, transform 0.15s";
    cartItem.style.opacity    = "0";
    cartItem.style.transform  = "translateX(10px)";
  }
 
  setCartLoading(true);
 
  try {
    // Fetch live cart to get correct line index at time of removal
    const cartRes  = await fetch("/cart.js");
    const cartData = await cartRes.json();
    const lineIndex = cartData.items.findIndex(i => i.variant_id === variantId) + 1;
 
    if (!lineIndex) {
      console.error("Could not find item in cart");
      if (cartItem) { cartItem.style.opacity = "1"; cartItem.style.transform = ""; }
      setCartLoading(false);
      return;
    }
 
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [variantId]: 0 } }),
    });
 
    if (res.status >= 400) {
      console.error("Failed to remove item", await res.text());
      if (cartItem) { cartItem.style.opacity = "1"; cartItem.style.transform = ""; }
      setCartLoading(false);
      return;
    }
  } catch (error) {
    console.error("removeItem fetch failed", error);
    if (cartItem) { cartItem.style.opacity = "1"; cartItem.style.transform = ""; }
    setCartLoading(false);
    return;
  }
 
  await updateCart();
}
 
// ─── Remove button listeners ──────────────────────────────────────────────────
 
function addRemoveButtonListeners() {
  document.querySelectorAll(".remove_item").forEach((btn) => {
    btn.addEventListener("click", removeItem);
  });
}
 
// ─── Add-on items ─────────────────────────────────────────────────────────────
 
function addAddOnItemListeners() {
  document.querySelectorAll(".add-on-button").forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      event.preventDefault();
      await addToCart(btn);
    });
  });
}
 
// ─── Init ─────────────────────────────────────────────────────────────────────
 
addRemoveButtonListeners();
addAddOnItemListeners();
 
// ─── Money formatting ─────────────────────────────────────────────────────────
 
var formatMoney = function (cents, format) {
  if (typeof cents == "string") cents = cents.replace(".", "");
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
 
  function defaultOption(opt, def) { return typeof opt == "undefined" ? def : opt; }
 
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal   = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts   = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents   = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
 
  var value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":                                  value = formatWithDelimiters(cents, 2);           break;
    case "amount_no_decimals":                      value = formatWithDelimiters(cents, 0);           break;
    case "amount_with_comma_separator":             value = formatWithDelimiters(cents, 2, ".", ","); break;
    case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
  }
  return formatString.replace(placeholderRegex, value);
};